import { render, staticRenderFns } from "./WalletConnect.vue?vue&type=template&id=ad5a3ecc&"
import script from "./WalletConnect.vue?vue&type=script&lang=js&"
export * from "./WalletConnect.vue?vue&type=script&lang=js&"
import style0 from "./WalletConnect.vue?vue&type=style&index=0&id=ad5a3ecc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports